import styled from "styled-components";

export default styled.img`
  width: 60%;
  max-width: 250px;
`;
